import React from 'react';

const ServicesSoldChart = ({ meetings }) => {
  // Agrupar servicios vendidos de todas las reuniones
  const aggregatedServices = meetings.reduce((acc, meeting) => {
    if (meeting.servicesSold && Array.isArray(meeting.servicesSold)) {
      meeting.servicesSold.forEach(service => {
        if (service.name) {
          if (!acc[service.name]) {
            acc[service.name] = { quantity: 0, totalValue: 0 };
          }
          acc[service.name].quantity += service.quantity || 0;
          acc[service.name].totalValue += (service.quantity || 0) * (service.value || 0);
        }
      });
    }
    return acc;
  }, {});

  const chartData = Object.keys(aggregatedServices).map(serviceName => ({
    label: serviceName,
    quantity: aggregatedServices[serviceName].quantity,
    totalValue: aggregatedServices[serviceName].totalValue
  }));

  // Ordenar por cantidad vendida (o por valor total si se prefiere)
  chartData.sort((a, b) => b.quantity - a.quantity);

  const maxQuantity = Math.max(...chartData.map(d => d.quantity));
  const scaleFactor = 100 / (maxQuantity === 0 ? 1 : maxQuantity);

  if (chartData.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 mt-6">
        <h3 className="text-lg font-semibold text-[#0061A8] mb-4">Servicios Más Vendidos</h3>
        <p className="text-[#63666A] text-sm">No hay servicios vendidos registrados para este cliente aún.</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mt-6">
      <h3 className="text-lg font-semibold text-[#0061A8] mb-4">Servicios Más Vendidos (Cantidad)</h3>
      <div className="space-y-4">
        {chartData.map((item, index) => (
          <div key={index}>
            <div className="flex justify-between text-sm text-[#63666A]">
              <span>{item.label}: {item.quantity} unidades</span>
              <span>${item.totalValue.toFixed(2)}</span>
            </div>
            <div className="w-full bg-[#D1D3D4] rounded-full h-2.5">
              <div className="bg-teal-500 h-2.5 rounded-full" style={{ width: `${item.quantity * scaleFactor}%` }}></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesSoldChart;